import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CheckLastIssueOfMedication from './CheckLastIssueOfMedication';
import { IPermanentMedicament } from '../PermanentMedication/PernamentMedicationItem';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	medications: IPermanentMedicament[];
	patientId: string;
	onIssue: (medications: IPermanentMedicament[]) => void;
}

const CheckLastIssueOfMedicationModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.checkLastIssueOfMedication.modalTitle'
			size={Size.LG}>
			<CheckLastIssueOfMedication
				medications={props.medications}
				patientId={props.patientId}
				onIssue={props.onIssue}
			/>
		</BaseModal>
	);
};

export default CheckLastIssueOfMedicationModal;
